export default __webpack_public_path__ + "static/media/tab_4.00741578.svg";